import { gql, useLazyQuery } from '@apollo/client'

import { FULL_SHOP_SHORTCUT } from '@shared/api/shortcuts/shop'

import type { GeoPoint, Shop } from '@@types'


export type ShopsInPolygonQuery = {
  shopsInGeoPolygon: Shop[]
}

export type ShopsInPolygonVariables = {
  corners: GeoPoint[]
  useZone?: boolean
  style?: string
  shopImageStyle?: string
  iconStyle?: string
  customerType?: string
}

export const GQL_QUERY_SHOPS_IN_POLYGON = gql`
  query shopsInGeoPolygon (
    $corners: [GeoPointInput]!, 
    $useZone: Boolean,
    $style: String, 
    $shopImageStyle: String, 
    $iconStyle: String,
    $customerType: String
  ) {
    shopsInGeoPolygon(corners: $corners, useZone: $useZone, customerType: $customerType) {
      ${FULL_SHOP_SHORTCUT}
    }
  }
`

export const useLazyShopsInGeoPolygon = () =>
  useLazyQuery<ShopsInPolygonQuery, ShopsInPolygonVariables>(GQL_QUERY_SHOPS_IN_POLYGON, {
    fetchPolicy: 'network-only'
  })
